import { useLocation } from "react-router-dom";

const PATHS_TO_HIDE = [
  "/busca/passagens-aereas/resultados",
  "/busca/passagens-aereas/checkout",
  "/busca/hospedagens/resultados",
  "/busca/passagens-onibus/resultados",
  "/busca/alugar-carros/resultados",
  "/busca/hospedagens/detalhes",
];

export const useTabBarVisibility = () => {
  const location = useLocation();

  const isOrderDetail =
    /^\/pedidos\/[^/]+/.test(location.pathname) && location.pathname !== "/pedidos/meus-pedidos";

  const shouldHide =
    PATHS_TO_HIDE.some((path) => location.pathname.startsWith(path)) || isOrderDetail;

  return !shouldHide;
};
